$(document).ready(function() {
    $('[data-trigger-campaign-id]').on('click', function(e) {
      e.preventDefault();

      if($('[data-campaign-id="'+$(this).data('trigger-campaign-id')+'"]').length) {
        $('[data-campaign-id="'+$(this).data('trigger-campaign-id')+'"]').click();
      }
    });

    $('body').on('mouseover', function() {
        $('.trigger-mega-nav').removeClass('triggered');
        $('.mega-nav').removeClass('visible');
    })
    $('.trigger-mega-nav').on('mouseover', function(e) {
        e.stopPropagation();
        $(this).addClass('triggered');
        $('.mega-nav').addClass('visible')
    })
    $('body').on('mouseover', '.mega-nav.visible', function(e) {
        e.stopPropagation();
        $(this).addClass('triggered');
    })

    if($('.stories-carousel .stories').length) {
        $('.stories-carousel .stories').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="M10 1 2 9l8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            nextArrow: `<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="m1 1 8 8-8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`
        });
    }

    if($('.ingredients-carousel .ingredients').length) {
        var windowWidth = window.innerWidth;
        var imageCount = $('.ingredients-carousel .ingredients .ingredient').length;
        var imageSize = 120;
        var slidesToShow = 9;
        if(windowWidth/imageSize < slidesToShow) slidesToShow = windowWidth/imageSize - 2;

        $('.ingredients-carousel .ingredients').slick({
            dots: false,
            arrows: false,
            infinite: true,
            draggable: true,
            speed: 300,
            slidesToShow: parseInt(slidesToShow),
            swipeToSlide: true,
            centerMode: true,
            variableWidth: true,
            initialSlide: parseInt(imageCount/2)
        });
    }

    if($('.products-carousel:not(.mentioned-products-carousel)').length) {
        $('.products-carousel:not(.mentioned-products-carousel)').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: `<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="M10 1 2 9l8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            nextArrow: `<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="m1 1 8 8-8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            responsive: [
                {
                    breakpoint: 749,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                    }
                }
            ] 
        });
    }

    if($('.mentioned-products-carousel').length) {
        $('.mentioned-products-carousel').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: `<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="M10 1 2 9l8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            nextArrow: `<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="m1 1 8 8-8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            responsive: [
                {
                    breakpoint: 749,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                    }
                }
            ] 
        });
    }

    $('.footer-links h3').on('click', function(e) {
        if(window.innerWidth < 749) {
            $(this).toggleClass('active');
        }
    });

    $('body').on('click', function() {
        if($('.mobile-nav--close').length) window.theme.MobileNav.closeMobileNav()
    });

    $('.close-mobile-nav').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.theme.MobileNav.closeMobileNav()
    });

    $('.js-mobile-nav-toggle, .mobile-nav-wrapper').on('click', function(e) {
        e.stopPropagation()
    })

    if($('.pdp-media-carousel').length) {
        $('.pdp-media-carousel').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="M10 1 2 9l8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            nextArrow: `<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="m1 1 8 8-8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`
        });
    }

    $('.pdp-purchase-type').on('click', function(e) {
        e.preventDefault();

        if(!$(this).hasClass('checked')) {
            $('.pdp-purchase-type.checked').find('input').prop('checked', false);
            $('.pdp-purchase-type.checked').removeClass('checked');
            $(this).addClass('checked');
            $(this).find('input').prop('checked',true);

            if($(this).hasClass('single-purchase')) {
                $(this).closest('form').find('input[name="properties[shipping_interval_frequency]"]').prop('disabled', true);
                $(this).closest('form').find('input[name="properties[shipping_interval_unit_type]"]').prop('disabled', true);
            } else {
                $(this).closest('form').find('input[name="properties[shipping_interval_frequency]"]').prop('disabled', false);
                $(this).closest('form').find('input[name="properties[shipping_interval_unit_type]"]').prop('disabled', false);
            }
        }
    });

    $('.pdp-details-entry').on('click', function(e) {
        e.preventDefault();

        $(this).toggleClass('extended');
    })

    $('.pdp-faqs__question-group').on('click', function(e) {
        e.preventDefault();

        $(this).toggleClass('extended');
    })

    function imageZoom(imgID, resultID) {
        var img, lens, result, cx, cy;
        img = document.getElementById(imgID);
        result = document.getElementById(resultID);
        /* Create lens: */
        lens = document.createElement("DIV");
        lens.setAttribute("class", "img-zoom-lens");
        /* Insert lens: */
        img.parentElement.insertBefore(lens, img);
        /* Calculate the ratio between result DIV and lens: */
        cx = result.offsetWidth / lens.offsetWidth;
        cy = result.offsetHeight / lens.offsetHeight;
        /* Set background properties for the result DIV */
        result.style.backgroundImage = "url('" + img.src + "')";
        result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
        /* Execute a function when someone moves the cursor over the image, or the lens: */
        lens.addEventListener("mousemove", moveLens);
        img.addEventListener("mousemove", moveLens);
        /* And also for touch screens: */
        lens.addEventListener("touchmove", moveLens);
        img.addEventListener("touchmove", moveLens);
        function moveLens(e) {
          var pos, x, y;
          /* Prevent any other actions that may occur when moving over the image */
          e.preventDefault();
          /* Get the cursor's x and y positions: */
          pos = getCursorPos(e);
          /* Calculate the position of the lens: */
          x = pos.x - (lens.offsetWidth / 2);
          y = pos.y - (lens.offsetHeight / 2);
          /* Prevent the lens from being positioned outside the image: */
          if (x > img.width - lens.offsetWidth) {x = img.width - lens.offsetWidth;}
          if (x < 0) {x = 0;}
          if (y > img.height - lens.offsetHeight) {y = img.height - lens.offsetHeight;}
          if (y < 0) {y = 0;}
          /* Set the position of the lens: */
          lens.style.left = x + "px";
          lens.style.top = y + "px";
          /* Display what the lens "sees": */
          result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
        }
        function getCursorPos(e) {
          var a, x = 0, y = 0;
          e = e || window.event;
          /* Get the x and y positions of the image: */
          a = img.getBoundingClientRect();
          /* Calculate the cursor's x and y coordinates, relative to the image: */
          x = e.pageX - a.left;
          y = e.pageY - a.top;
          /* Consider any page scrolling: */
          x = x - window.pageXOffset;
          y = y - window.pageYOffset;
          return {x : x, y : y};
        }
      }

    $('.js-open-nutrition-modal').on('click', function(e){
        e.preventDefault();
        var toAppend = `<div class="premama-modal">            
            <div class="premama-modal-wrapper">
                <a href="#" class="premama-modal-close"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <g fill="#000" fill-rule="evenodd">
                    <path d="m1.414 0 14.142 14.142-1.414 1.414L0 1.414z"/>
                    <path d="M14.142 0 0 14.142l1.414 1.414L15.556 1.414z"/>
                </g>
                </svg></a>
                <div class="premama-modal-content premama-nutrition-carousel">
                <img id="supplementImage1" src="`+$(this).data('image')+`" alt="Supplement Facts">
              
                    `;
        if($(this).data('image2')) toAppend += `<img id="supplementImage2" src="`+$(this).data('image2')+`" alt="Supplement Facts">`;
        if($(this).data('image3')) toAppend += `<img id="supplementImage3" src="`+$(this).data('image3')+`" alt="Supplement Facts">`;
        toAppend += `                    
                </div>
            </div>
        </div>`;
        $('body').append(toAppend);

        $('.premama-nutrition-carousel').slick({
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="M10 1 2 9l8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            nextArrow: `<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="m1 1 8 8-8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`
        });

        $('#supplementImage1').imageZoom();
        if($(this).data('image2')) $('#supplementImage2').imageZoom();
        if($(this).data('image3')) $('#supplementImage3').imageZoom();

    })

    $('body').on('click', '.premama-modal-close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.premama-modal').remove();
    })

    $('body').on('click', '.premama-modal-wrapper', function(e) {
        e.stopPropagation();
    })

    $('body').on('click', '.premama-modal', function(e) {
        $(this).remove();
    })

    if($('.research-persons').length) {
        $('.research-persons').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
            initialSlide: 1,
            prevArrow: `<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="M10 1 2 9l8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            nextArrow: `<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="m1 1 8 8-8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            responsive: [
                {
                    breakpoint: 749,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      arrows: false
                    }
                }
            ] 

        });
    }

    if($('.clinical-studies-carousel').length) {
        $('.clinical-studies-carousel').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: `<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="M10 1 2 9l8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            nextArrow: `<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18">
                            <path d="m1 1 8 8-8 8" stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd"/>
                        </svg>`,
            responsive: [
                {
                    breakpoint: 749,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      centerMode: true,
                      arrows: false
                    }
                }
            ] 
        });
    }

    $('.our-story-video').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('playing');
        if($(this).hasClass('playing')) $(this).find('video')[0].play();
        else  $(this).find('video')[0].pause();
    })

    $('.faq-qa').on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('extended');
    })
    $('.faq-qa .answer').on('click', function(e) {
        e.stopPropagation();
    })
    $('.faq-qa a').on('click', function(e) {
        e.preventDefault();
    })
    $('.account-stage select').on('change', function(e) {
      $('.account-stage .footer-email-submit').removeClass('hide');
    })

    $('.search-selector a').on('click', function(e) {
        e.preventDefault();
        $('.search-selector a').removeClass('selected');
        $(this).addClass('selected');
        $('.search-category').hide();
        if($(this).data('show')) {
            $('.search-category#'+$(this).data('show')).show();
        }
    });

    $('.pdp-short-description .read-more').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.pdp-short-description').find('.pdp-short-description-short').hide();
        $(this).closest('.pdp-short-description').find('.pdp-short-description-full').show();
    });

    $('.pdp-short-description .read-less').on('click', function(e) {
        e.preventDefault();
        $(this).closest('.pdp-short-description').find('.pdp-short-description-short').show();
        $(this).closest('.pdp-short-description').find('.pdp-short-description-full').hide();
    });

    /* $("body").on('click',".or_normal_price, .or_subscription_price", function(e){ 
        e.preventDefault();

        if($(this).parent().find('.or_subscription_price').length) $(this).parent().find('.or_subscription_price').toggleClass('selected');
        if($(this).parent().find('.or_normal_price').length) $(this).parent().find('.or_normal_price').toggleClass('selected');

        if($(this).hasClass('or_normal_price') && $(this).hasClass('selected')) $(this).closest('.product-card-description').find('.js-add-to-cart').addClass('single-buy');
        else  $(this).closest('.product-card-description').find('.js-add-to-cart').removeClass('single-buy');
    }) */
})